<!--
 * @Description: 
 * @Author: wjx 
 * @Date: 2019-05-09 18:39:52
 -->
<template>
  <div
    :class="{ fullscreen: fullscreen }"
    class="tinymce-container"
    :style="{ width: containerWidth }"
  >
    <textarea :id="tinymceId" class="tinymce-textarea" />
    <!-- <div class="editor-custom-btn-container">
      <editorImage
        color="#1890ff"
        class="editor-upload-btn"
        @successCBK="imageSuccessCBK"
      />
    </div> -->
  </div>
</template>

<script>
/**
 * docs:
 * https://panjiachen.github.io/vue-element-admin-site/feature/component/rich-editor.html#tinymce
 */
// import editorImage from './components/EditorImage';
import plugins from './plugins';
import toolbar from './toolbar';
import { uploadApi } from '@data-source/common/apis';
import { MAX_IMAGE_SIZE } from '@constants/blob';

const httpRequest = async file => {
  return uploadApi({ file });
};
export default {
  name: 'XrkTinymce',
  // components: { editorImage },
  props: {
    // 图片宽高比
    limitSizeRatio: {
      type: Number,
      default: 0
    },
    readonly: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: function () {
        return (
          'vue-tinymce-' +
          +new Date() +
          ((Math.random() * 1000).toFixed(0) + '')
        );
      }
    },
    value: {
      type: String,
      default: ''
    },
    toolbar: {
      type: Array,
      required: false,
      default() {
        return [];
      }
    },
    menubar: {
      type: String,
      default: 'file edit insert view format table'
    },
    height: {
      type: [Number, String],
      required: false,
      default: 360
    },
    width: {
      type: [Number, String],
      required: false,
      default: 'auto'
    },
    // 是否显示下方字数
    statusbar: {
      type: Boolean,
      required: false,
      default: false
    },
    //上传图片是否自动设置尺寸大小
    image_dimensions: {
      type: Boolean,
      required: false,
      default: true
    },
    //使用必须关闭自动设置尺寸[width，height]
    limitImgSize: {
      type: Array,
      required: false,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      hasChange: false,
      hasInit: false,
      tinymceId: this.id,
      fullscreen: false,
      languageTypeList: {
        en: 'en',
        zh: 'zh_CN'
      }
    };
  },
  computed: {
    containerWidth() {
      const width = this.width;
      if (/^[\d]+(\.[\d]+)?$/.test(width)) {
        // matches `100`, `'100'`
        return `${width}px`;
      }
      return width;
    }
  },
  watch: {
    value(val) {
      if (!this.hasChange && this.hasInit) {
        this.$nextTick(() =>
          window.tinymce.get(this.tinymceId).setContent(val || '')
        );
      }
    }
  },
  mounted() {
    this.initTinymce();
    //图片传入限制尺寸，就不能手动输入地址
    if (this.limitImgSize.length > 0) {
      this.$nextTick(() => {
        this.getImgDom();
      });
    }
  },
  activated() {
    this.initTinymce();
  },
  // deactivated() {
  //   this.destroyTinymce();
  // },
  // unmounted() {
  //   this.destroyTinymce();
  // },
  methods: {
    initTinymce() {
      const self = this;
      window.tinymce.init({
        image_dimensions: this.image_dimensions,
        readonly: this.readonly,
        language: 'zh_CN',
        branding: false,
        selector: `#${this.tinymceId}`,
        height: this.height,
        body_class: 'panel-body ',
        object_resizing: false,
        toolbar: this.toolbar.length > 0 ? this.toolbar : toolbar,
        menubar: this.menubar,
        plugins: plugins,
        statusbar: this.statusbar,
        end_container_on_empty_block: true,
        powerpaste_word_import: 'clean',
        code_dialog_height: 450,
        code_dialog_width: 1000,
        advlist_bullet_styles: 'square',
        advlist_number_styles: 'default',
        imagetools_cors_hosts: ['www.tinymce.com', 'codepen.io'],
        default_link_target: '_blank',
        link_title: false,
        nonbreaking_force_tab: true, // inserting nonbreaking space &nbsp; need Nonbreaking Space Plugin
        init_instance_callback: editor => {
          if (self.value) {
            editor.setContent(self.value);
          }
          self.hasInit = true;
          editor.on('NodeChange Change KeyUp SetContent', () => {
            this.hasChange = true;
            this.$emit('input', editor.getContent());
          });
        },
        setup(editor) {
          editor.on('FullscreenStateChanged', e => {
            self.fullscreen = e.state;
          });
        },
        // 整合七牛上传
        // images_dataimg_filter(img) {
        //   setTimeout(() => {
        //     const $image = $(img);
        //     $image.removeAttr('width');
        //     $image.removeAttr('height');
        //     if ($image[0].height && $image[0].width) {
        //       $image.attr('data-wscntype', 'image');
        //       $image.attr('data-wscnh', $image[0].height);
        //       $image.attr('data-wscnw', $image[0].width);
        //       $image.addClass('wscnph');
        //     }
        //   }, 0);
        //   return img;
        // },
        async images_upload_handler(blobInfo, success, failure, progress) {
          if (self.limitSizeRatio) {
            const file = blobInfo.blob();
            if (!file.type.match('image.*')) {
              failure('请选择一个图片文件');
            }
            const reader = new FileReader();
            reader.onload = function (e) {
              const img = new Image();
              img.onload = function () {
                if (img.height / img.width !== self.limitSizeRatio) {
                  failure(`请上传宽/高比为1/${self.limitSizeRatio}的图片`);
                }
              };
              img.src = e.target.result; // 设置img的src为读取后的数据URL
            };
            reader.readAsDataURL(file); // 读取文件内容为DataURL
          }
          if (blobInfo.blob().size > MAX_IMAGE_SIZE) {
            failure('请上传5M内的图片');
            return;
          }
          //限制图片尺寸大小
          if (self.limitImgSize.length > 0) {
            try {
              await self.isLimitImgSize(blobInfo.blob(), self.limitImgSize);
            } catch (error) {
              failure(error);
              return;
            }
          }
          try {
            progress(0);
            const { data } = await httpRequest(blobInfo.blob());
            success(data.fileUrl);
            progress(100);
          } catch (e) {
            failure('出现未知问题，刷新页面，或者联系程序员');
          }
        }
      });
      // if (this.readonly) {
      //   window.tinymce.activeEditor.setMode('readonly'); //只读模式
      // }
    },
    destroyTinymce() {
      const tinymce = window.tinymce.get(this.tinymceId);
      if (this.fullscreen) {
        tinymce.execCommand('mceFullScreen');
      }

      if (tinymce) {
        tinymce.destroy();
      }
    },
    setContent(value) {
      window.tinymce.get(this.tinymceId).setContent(value);
    },
    getContent() {
      window.tinymce.get(this.tinymceId).getContent();
    },
    imageSuccessCBK(arr) {
      const self = this;
      arr.forEach(v => {
        window.tinymce
          .get(self.tinymceId)
          .insertContent(`<img class="wscnph" src="${v.url}" >`);
      });
    },
    /**
     *
     * @param blob
     * @param size //限制图片尺寸大小
     */
    isLimitImgSize(blob, size) {
      return new Promise((resolve, reject) => {
        let restrictRatio = 2 / 3;
        let restrictWidth = size[0];
        let restrictHight = size[1];
        var img = new Image();
        var url = URL.createObjectURL(blob);
        img.src = url;
        img.onload = () => {
          let imgRatio = img.width / img.height;
          if (imgRatio !== restrictRatio) {
            if (img.width <= restrictWidth) {
              if (img.height <= restrictHight) {
                resolve();
              } else {
                reject(`请上传${size[0]}*${size[1]}尺寸内的图片！`);
              }
            } else {
              //上传的图片宽高同时缩小
              let lessenWidthRatio = img.width / restrictWidth;
              let lessenHightSize = img.height / lessenWidthRatio;
              if (lessenHightSize <= restrictHight) {
                resolve();
              } else {
                reject(`请上传${size[0]}*${size[1]}尺寸内的图片！`);
              }
            }
          } else {
            resolve();
          }
        };
      });
    },
    /***
     * Description:限制图片尺寸大小的时候地址输入框不能输入
     */
    getImgDom() {
      let imgiDom = null;
      setTimeout(() => {
        imgiDom = document.querySelector('.mce-i-image');
        imgiDom.parentNode.parentNode.addEventListener('click', () => {
          let mcerResetDom = null;
          let getMceTextBoxDOM = () => {
            setTimeout(() => {
              mcerResetDom = document.querySelector('.mce-reset');
              if (mcerResetDom) {
                let mceTextboxDom = mcerResetDom.querySelector('.mce-textbox');
                mceTextboxDom.setAttribute('disabled', true);
                mceTextboxDom.style.background = '#f5f7fa';
                mceTextboxDom.style.color = '#c0c4cc';
                mceTextboxDom.style.cursor = 'not-allowed';
              }
              if (['', null].includes(mcerResetDom)) {
                getMceTextBoxDOM();
              } else {
                return;
              }
            }, 50);
          };
          getMceTextBoxDOM();
        });
        if (['', null].includes(imgiDom)) {
          this.getDom();
        } else {
          return;
        }
      }, 50);
    }
  }
};
</script>

<style scoped>
.tinymce-container {
  position: relative;
  line-height: normal;
}
.tinymce-container >>> .mce-fullscreen {
  z-index: 10000;
}
.tinymce-textarea {
  visibility: hidden;
  z-index: -1;
}
.editor-custom-btn-container {
  position: absolute;
  right: 4px;
  top: 4px;
  /*z-index: 2005;*/
}
.fullscreen .editor-custom-btn-container {
  z-index: 10000;
  position: fixed;
}
.editor-upload-btn {
  display: inline-block;
}
</style>
